import React from 'react';
import { Typography, Tooltip, Box, CircularProgress } from '@mui/material';
import { CopyIconButton } from 'src/components/CopyButton/CopyButton';
import { FacebookTokenDisplayProps } from 'src/components/FacebookToken/FacebookToken.types';
import { useTranslation } from 'react-i18next';

export const FacebookTokenDisplay: React.FC<FacebookTokenDisplayProps> = ({
  token,
  expiresAt,
  renewAccessTokenLoading,
}) => {
  const { t } = useTranslation();

  if (!expiresAt || renewAccessTokenLoading) {
    return <CircularProgress size={24} />;
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Tooltip
        title={`${t('configScreen.facebookToken.expiration')}: ${expiresAt}`}
        enterDelay={100}
        leaveDelay={300}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '8px',
              padding: '8px 16px',
              backdropFilter: 'blur(15px)',
              boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
              maxWidth: '400px',
            },
          },
        }}
        placement="top">
        <Typography
          variant="body1"
          align="center"
          textAlign="left"
          color="white"
          noWrap
          sx={{
            overflow: 'hidden',
            maxWidth: '15%',
            maxHeight: '100%',
            lineHeight: '1-5',
            whiteSpace: 'normal',
          }}>
          {token}
        </Typography>
      </Tooltip>
      <CopyIconButton textToCopy={token} />
    </Box>
  );
};
